module.exports = __webpack_public_path__ + "static/img/help_05_03.9a1f128.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_05_03.png
// module id = 694
// module chunks = 140